/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface DeleteContact$Params {
  organisation_id: string;
  contact_id: number;
  check?: boolean;
}

export function deleteContact(
  http: HttpClient,
  rootUrl: string,
  params: DeleteContact$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Status>> {
  const rb = new RequestBuilder(rootUrl, deleteContact.PATH, "delete");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("contact_id", params.contact_id, {});
    rb.query("check", params.check, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Status>;
    }),
  );
}

deleteContact.PATH = "/surfdomeinen/organisations/{organisation_id}/contacts/{contact_id}";
